<template>
  <tr class="data-row" :class="{ 'alternate-row': isAlternate }">
    <td class="data-row-text">
      {{ name }}
    </td>
    <td class="text-left">
      <BouncingDots v-if="contributionValuesLoading" />
      <span v-else class="data-row-text">{{ yearToDate }}</span>
    </td>
    <td class="text-left">
      <BouncingDots v-if="contributionValuesLoading" />
      <span v-else class="data-row-text">{{ rollingTwelveMonths }}</span>
    </td>
    <td>
      <ThemedTextField
        dense
        outlined
        hide-details
        class="input-field"
        :value="input"
        @input="handleInputChange"
        type="number"
        :step="0.01"
      />
    </td>
  </tr>
</template>
          
<script>
import BouncingDots from "@/views/components/BouncingDots.vue";
import ThemedTextField from "@/core/ThemedTextField.vue";
export default {
  name: "DataTable",
  components: {
    BouncingDots,
    ThemedTextField,
  },
  props: {
    name: {
      type: String,
      required: true,
    },
    yearToDate: {
      type: String,
      required: true,
    },
    isAlternate: {
      type: Boolean,
      required: false,
      default: false,
    },
    rollingTwelveMonths: {
      type: String,
      required: true,
    },
    input: {
      type: Number,
      required: true,
    },
    onChange: {
      type: Function,
      required: true,
    },
    contributionValuesLoading: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data: function () {
    return {};
  },
  methods: {
    handleInputChange(value) {
      // Convert to number since the input type is number
      const numericValue = parseFloat(value) || 0;
      this.onChange(numericValue);
    },
  },
};
</script>
          
    <style scoped>
/* Header Styles */
.header-title-row {
  background-color: var(--color-primary) !important;
  color: var(--color-text) !important;
  font-size: 1.1em;
  height: 48px;
}

.header-main-row {
  background-color: var(--color-primary) !important;
  color: var(--color-text) !important;
}

.header-cell {
  padding: 0 16px !important;
  height: 48px;
  font-weight: 500 !important;
  white-space: nowrap;
  cursor: default;
  color: var(--color-text) !important;
}

.header-cell.sortable {
  cursor: pointer;
}

.header-cell.sortable:hover {
  background-color: var(--color-primary-light) !important;
}

.header-filter-row {
  background-color: var(--color-primary-light) !important;
}

.header-filter {
  margin: 8px 4px !important;
}

/* Existing Body Styles */
.summary-row {
  background-color: var(--color-surface) !important;
  font-weight: bold;
  border-bottom: 2px solid var(--color-border) !important;
}

.data-row {
  height: 48px;
  transition: background-color 0.2s;
  background-color: var(--color-bg) !important;
}

.data-row:hover {
  background-color: var(--color-overlay) !important;
}

.highlight-row {
  background-color: var(--color-primary-light) !important;
}

.alternate-row {
  background-color: var(--color-surface) !important;
}

.footer-row {
  background-color: var(--color-surface) !important;
  border-top: 2px solid var(--color-border) !important;
}

.input-field {
  max-width: 120px;
  font-size: 0.95em;
}

td {
  padding: 0 16px !important;
  vertical-align: middle !important;
  border-bottom: 1px solid var(--color-border) !important;
}

.text-right {
  text-align: right !important;
}

.data-row-text {
  color: var(--color-text) !important;
  font-size: 0.95em;
}

/* Ensure compatibility with v-data-table */
.v-data-table {
  background-color: var(--color-bg) !important;
  color: var(--color-text) !important;
}

.v-data-table th {
  background-color: var(--color-primary) !important;
  color: var(--color-text) !important;
  border-bottom: 1px solid var(--color-border) !important;
}

.v-data-table td {
  border-bottom: 1px solid var(--color-border) !important;
  color: var(--color-text) !important;
}

.v-data-table tbody tr:hover {
  background-color: var(--color-overlay) !important;
}

/* Theme-aware input field styling */
.v-text-field {
  background-color: var(--color-surface) !important;
}

.v-text-field .v-input__control {
  background-color: var(--color-surface) !important;
}

.v-text-field .v-input__slot {
  background-color: var(--color-surface) !important;
  border-color: var(--color-border) !important;
}

.v-text-field input {
  color: var(--color-text) !important;
}

.v-text-field .v-label {
  color: var(--color-text-muted) !important;
}
</style>
    
    